import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { CustomerContactChannelType } from '../../../interfaces/customerContactChannelType';
import { CustomerContactPurposeType } from '../../../interfaces/CustomerContactPurposeType';
import { AuthService } from '../../../services/auth.service';
import { GlobalsService } from '../../../services/globals.service';
import { GestionTercerosService } from '../../../../dms/modulos/general/componentes/gestion-terceros/gestion-terceros.service';
import { ImprimirService } from '../../../services/imprimir.service';
import { ImpresosEnum } from '../../../enums/imprimir.enum';
import { IParamsImprimir } from '../../../interfaces/params-imprimir.interface';
import { TranslateService } from '@ngx-translate/core';
import { pairwise, startWith, takeUntil } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
    selector: 'app-contact-information',
    templateUrl: './contact-information.component.html',
    styleUrls: ['./contact-information.component.scss']
})

export class ContactInformationComponent implements OnInit, OnDestroy{
    @Input() dataCustomer: any;
    @Input() formMode: boolean;
    @Input() modoEdicion: boolean;
    @ViewChild('content', { static: false }) content;
    @Output() excel = new EventEmitter<any>();

    autorizacion: string;
    autorizaAll: number;
    autorizarDatos: boolean;

    pais: string;
    code: string;
    deshabilitarCampos: boolean;
    messageResult: boolean;
    telefono: CustomerContactChannelType;
    mailing: CustomerContactChannelType;
    sms: CustomerContactChannelType;
    whatsApp: CustomerContactChannelType;
    redesSociales: CustomerContactChannelType;
    correoPostal: CustomerContactChannelType;
    fax: CustomerContactChannelType;

    fechaActual: any;
    fechaMas12: any;
    customerContactChannelTypeList: Array<CustomerContactChannelType>;
    customerContactChannelType: CustomerContactChannelType;

    customerContactPurposeTypeList: Array<CustomerContactPurposeType>;
    customerContactPurposeType: CustomerContactPurposeType;

    formGroupFinalidades: FormGroup;

    showModalGeneric: boolean = false;
    generic_title: string;
    generic_textButtonOk: string;
    generic_textButtonCancel: string;
    generic_aspa: boolean;
    generic_message: string;
    generic_isButtonOk: boolean;
    generic_isButtonCancel: boolean;
    mailMal: boolean;
    privacyData = [{description: 'labels.noFirmado', value: ''},
                  {description: 'labels.siAutoriza', value: 'S'},
                  {description: 'labels.noAutoriza', value: 'N'}];
    privacyOldValue: string;
    permCamposCon: boolean;
    permFechaFirma: boolean;
    permFechaFinalidades: boolean;
    clienteNuevo: boolean;
    showModalNewContract: boolean = false;
    canShowModalNC: boolean = true;
    destroySub: Subject<void>;
    showModalOnSingDate: boolean = true;
    showModalComunicationAlert: boolean = false;
    canShowModalCA: boolean = true;
    checkBoxComunVal = null;
    filial: any;

    constructor(
        private _authService: AuthService,
        private _globals: GlobalsService,
        private _imprimirService: ImprimirService,
        public _gestionTercerosService: GestionTercerosService,
        private _translateService: TranslateService) {
        this.fechaActual = moment().startOf('day').utc().toDate();
        this.fechaMas12 = moment().startOf('day').utc().add(12, 'year').toDate();
        this.autorizaAll = 0;
    }

    ngOnDestroy(): void {
        this.destroySub.next();
        this.destroySub.complete();
    }

    ngOnInit() {
        this.filial = this._authService.getFilial();
        this.destroySub = new Subject<void>();
        this.translatePrivacyData()
        this.validarEmail(this._gestionTercerosService.customerForm.controls.contactInformation.get('email').value);
        this.canShowModalNC = true;
        this.canShowModalCA = true;
        this._gestionTercerosService.customerForm.controls.contactInformation.get('email')
            .valueChanges.subscribe(value => {
                this.validarEmail(value);
            })

        this.pais = this._authService.getDataPais();
        if (this.formMode || !this.modoEdicion) {
            this.deshabilitarCampos = true;
        } else {
            this.deshabilitarCampos = false;
        }

        this.loadFormGroup();
        this.validateContactData(false);
        this.customerContactChannelTypeList = this._gestionTercerosService.customerForm.controls.contactInformation.get('customerContactChannelTypeList').value;

        if (!this._gestionTercerosService.newCustomer) {
            this.clienteNuevo = false;
            this.comprobarAutorizationAll();
            this.correoPostal = this.customerContactChannelTypeList[0];
            this.fax = this.customerContactChannelTypeList[1];
            this.mailing = this.customerContactChannelTypeList[2];
            this.redesSociales = this.customerContactChannelTypeList[3];
            this.sms = this.customerContactChannelTypeList[4];
            this.telefono = this.customerContactChannelTypeList[5];
            this.whatsApp = this.customerContactChannelTypeList[6];
            this.customerContactPurposeTypeList = this._gestionTercerosService.customerForm.controls.contactInformation.get('customerContactPurposeTypeList').value;
            this.recuperarFechasPurpose(this.customerContactPurposeTypeList);
        } else {
            this.clienteNuevo = true;
            this.autorizaAll = 0;
            this.correoPostal = this.customerContactChannelTypeList[0];
            this.fax = this.customerContactChannelTypeList[1];
            this.mailing = this.customerContactChannelTypeList[2];
            this.redesSociales = this.customerContactChannelTypeList[3];
            this.sms = this.customerContactChannelTypeList[4];
            this.telefono = this.customerContactChannelTypeList[5];
            this.whatsApp = this.customerContactChannelTypeList[6];
            this.customerContactPurposeTypeList = this._gestionTercerosService.customerForm.controls.contactInformation.get('customerContactPurposeTypeList').value;
        }
        this.suscripcionesFormulario();
    }

    suscripcionesFormulario(){
        this._gestionTercerosService.customerForm.get('contactInformation').get('privacy').valueChanges
        .pipe(
            takeUntil(this.destroySub),
            startWith(this._gestionTercerosService.customerForm.controls.contactInformation.get('privacy').value),
            pairwise()
        )
        .subscribe(([valAnterior, valActual]) => {
            this.privacyOldValue = valAnterior;
            this.validateContactData(true);
        });

        this._gestionTercerosService.customerForm.get('contactInformation').get('dateSignatureConsentDocument').valueChanges
        .pipe(takeUntil(this.destroySub))
        .subscribe((data) => {
            if(this.autorizacion === 'S' && data !== null){
                this.showModalOnSingDate = false;
                this.onChangeDateSigConsent(data);
            }
        });

        const camposTratamientoDatos = ['customerContactChannelTypeList', 'allowContactBrand', 'thirdAssignment', 'allowProfilingBrand', 'customerContactPurposeTypeList'];
        camposTratamientoDatos.forEach(campo =>{
            this._gestionTercerosService.customerForm.get('contactInformation').get(campo).valueChanges
            .pipe(takeUntil(this.destroySub))
            .subscribe(valor => {
                const dateSignatureConsent = this._gestionTercerosService.customerForm.get('contactInformation').get('dateSignatureConsentDocument');
                if(this.autorizacion === 'S' || this.autorizacion === 'N'){
                    if((dateSignatureConsent.value &&
                        this._globals.getDateFormatYMD(dateSignatureConsent.value) !== this._globals.getDateFormatYMD(this.fechaActual) ||
                        !dateSignatureConsent.value) &&
                        this.autorizacion === 'S' &&
                        this.showModalOnSingDate &&
                        this.canShowModalNC === true){
                            // this.showModalNewContract = true;
                            this.actualizarFecha();
                    }
                }
            })
        })
    }

    translatePrivacyData() {
        this.privacyData.forEach((obj)=>{
            this._translateService.get(obj.description).subscribe((translated)=>{
                obj.description = translated;
            })
        })
    }

    validateContactDataInit(){
        this.autorizacion = this._gestionTercerosService.customerForm.controls.contactInformation.get('privacy').value;
        if(this.autorizacion === ''){
            this.permCamposCon = false;
            this.permCamposEsp(false);
            this.permFechaFirma = false;
            this.permFechaFinalidades = false;
        }else if(this.autorizacion === 'S'){
            this.permCamposCon = true;
            this.permCamposEsp(true);
            this.permFechaFirma = true;
            this.permFechaFinalidades = true;
        }else if (this.autorizacion === 'N') {
            this.permCamposCon = false;
            this.permCamposEsp(false);
            this.permFechaFirma = true;
            this.permFechaFinalidades = false;
        }
    }

    validateContactData(isDropdown){
        this.autorizacion = this._gestionTercerosService.customerForm.controls.contactInformation.get('privacy').value;
            if(this.autorizacion === ''){
                if(isDropdown){
                    this.limpiarCampos();
                }
                this.permCamposCon = false;
                this.permCamposEsp(false);
                this.permFechaFirma = false;
                this.permFechaFinalidades = false;
            }else if(this.autorizacion === 'S'){
                this.permCamposCon = true;
                this.permCamposEsp(true);
                this.permFechaFirma = true;
                this.permFechaFinalidades = true;
                if(isDropdown){
                    if(this.canShowModalNC && this.privacyOldValue === 'N' && !this.clienteNuevo){
                        // this.showModalNewContract = true;
                        this.actualizarFecha();
                    }else{
                        this._gestionTercerosService.customerForm.controls.contactInformation.get('dateSignatureConsentDocument').setValue(this.fechaActual);
                        this.marcarSiNo(true, true);
                    }
                }
            }else if (this.autorizacion === 'N') {
                if(isDropdown){
                    this.limpiarCampos();
                    this._gestionTercerosService.customerForm.controls.contactInformation.get('dateSignatureConsentDocument').setValue(this.fechaActual);
                }
                this.permCamposCon = false;
                this.permCamposEsp(false);
                this.permFechaFirma = true;
                this.permFechaFinalidades = false;
                if(!this.clienteNuevo && this.privacyOldValue === 'S'){
                    this.generic_aspa = false;
                    this.generic_isButtonOk = true;
                    this.generic_isButtonCancel = false;
                    this.generic_title = 'labels.alert';
                    this.generic_message = 'alerts.alertaAvisarPartesInteresadasCambiosGDPR';
                    this.generic_textButtonOk = 'labels.aceptar';
                    this.generic_textButtonCancel = 'labels.cancelar';
                    this.showModalGeneric = true;
                }
            }else{
                //Si en privacy llega algun dato distinto a '', S, N
                this.permCamposCon = false;
                this.permCamposEsp(false);
                this.permFechaFirma = false;
                this.permFechaFinalidades = false;
            }
    }

    closeModalGeneric(event) {
        this.showModalGeneric = false;
    }

    closeModalComunicationAlert(event) {
        if(event.datosPopup === "aceptar"){
            this.selectBoxChangeCheck(this.checkBoxComunVal);
        }else{
            this.selectBoxChangeCheck(this.checkBoxComunVal, true);
        }
        this.showModalComunicationAlert = false;
        this.canShowModalCA = false;
    }

    closeModalNewContract(event){
        const privacy = this._gestionTercerosService.customerForm.controls.contactInformation.get('privacy').value;
        if(event.datosPopup === "aceptar"){
            if(this.privacyOldValue === 'N' && !this.clienteNuevo && privacy === 'S'){
                this._gestionTercerosService.customerForm.controls.contactInformation.get('dateSignatureConsentDocument').setValue(this.fechaActual);
                this.marcarSiNo(true, true);
            }else{
                this._gestionTercerosService.customerForm.controls.contactInformation.get('dateSignatureConsentDocument').setValue(this.fechaActual);
            }
        }
        this.showModalNewContract = false;
        this.canShowModalNC = false;
    }

    private actualizarFecha() {
        const privacy = this._gestionTercerosService.customerForm.controls.contactInformation.get('privacy').value;
        if(this.privacyOldValue === 'N' && !this.clienteNuevo && privacy === 'S'){
            this._gestionTercerosService.customerForm.controls.contactInformation.get('dateSignatureConsentDocument').setValue(this.fechaActual);
            this.marcarSiNo(true, true);
        }else{
            this._gestionTercerosService.customerForm.controls.contactInformation.get('dateSignatureConsentDocument').setValue(this.fechaActual);
        }
    }

    permCamposEsp(activo){
        if(activo){
            this._gestionTercerosService.customerForm.controls.contactInformation.get('allowContactBrand').enable({emitEvent: false});
            this._gestionTercerosService.customerForm.controls.contactInformation.get('allowProfilingBrand').enable({emitEvent: false});
            this._gestionTercerosService.customerForm.controls.contactInformation.get('thirdAssignment').enable({emitEvent: false});
        }else{
            this._gestionTercerosService.customerForm.controls.contactInformation.get('allowContactBrand').disable({emitEvent: false});
            this._gestionTercerosService.customerForm.controls.contactInformation.get('allowProfilingBrand').disable({emitEvent: false});
            this._gestionTercerosService.customerForm.controls.contactInformation.get('thirdAssignment').disable({emitEvent: false});
        }
    }

    comprobarAutorizationAll() {
        //si estan todos marcados hacemos check
        this.customerContactChannelTypeList.forEach(data => {
            if (data.IsActivated) {
                this.autorizaAll = this.autorizaAll + 1;
            }
        });
    }

    loadFormGroup() {
        this.formGroupFinalidades = new FormGroup({
            findCA: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            findCC: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            findES: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            findPE: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            findOT: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
        });

        // cada cambio en una fecha actualizamos el array pero por cada campo
        this.formGroupFinalidades.get('findCA').valueChanges
        .pipe(takeUntil(this.destroySub))
        .subscribe(val => {
            this.actualizamosArray(val, 'CA');
        });
        this.formGroupFinalidades.get('findCC').valueChanges
        .pipe(takeUntil(this.destroySub))
        .subscribe(val => {
            this.actualizamosArray(val, 'CC');
        });
        this.formGroupFinalidades.get('findES').valueChanges
        .pipe(takeUntil(this.destroySub))
        .subscribe(val => {
            this.actualizamosArray(val, 'ES');
        });
        this.formGroupFinalidades.get('findPE').valueChanges
        .pipe(takeUntil(this.destroySub))
        .subscribe(val => {
            this.actualizamosArray(val, 'PE');
        });
        this.formGroupFinalidades.get('findOT').valueChanges
        .pipe(takeUntil(this.destroySub))
        .subscribe(val => {
            this.actualizamosArray(val, 'OT');
        });
    }

    limpiarCampos() {
        // Desmarcamos todos los checkbox
        const incluirEspeciales = true;
        this.marcarSiNo(false, incluirEspeciales);

        // Quitamos todas las fechas
        this._gestionTercerosService.customerForm.controls.contactInformation.get('dateSignatureConsentDocument').setValue(null);
        this.formGroupFinalidades.get('findCA').setValue(null);
        this.formGroupFinalidades.get('findCC').setValue(null);
        this.formGroupFinalidades.get('findES').setValue(null);
        this.formGroupFinalidades.get('findPE').setValue(null);
        this.formGroupFinalidades.get('findOT').setValue(null);
    }

    actualizamosArray(fecha?, finalidad?) {
        if (this.customerContactPurposeTypeList) {
            const item = this.customerContactPurposeTypeList.find(item => item.PurposeTypeCode === finalidad);
            if (item) {
                item.EndDate = this._globals.getDateFormatForServerNoTime(fecha);
            } else {
                const newItem: CustomerContactPurposeType = {
                    CustomerCode: this.dataCustomer.CustomerCode,
                    EndDate: this._globals.getDateFormatForServerNoTime(fecha),
                    PurposeTypeCode: finalidad
                };
                this.customerContactPurposeTypeList.push(newItem);
            }
        } else {
            if(this.customerContactPurposeTypeList){
                this.customerContactPurposeTypeList.forEach(item => {
                    item.EndDate = this._globals.getDateFormatForServerNoTime(this.fechaActual);
                });
            }
        }
        this._gestionTercerosService.customerForm.controls.contactInformation.get('customerContactPurposeTypeList').setValue(this.customerContactPurposeTypeList);
    }

    // fechas que se cogen si el usuario viene de modificar o al cambiar de pestañas
    recuperarFechasPurpose(arrayPurpose) {
        arrayPurpose.forEach(item => {
            switch (item.PurposeTypeCode) {
                case 'CA':
                    if (item.EndDate) {
                        this.formGroupFinalidades.get('findCA').setValue(this._globals.getDateFormat(item.EndDate));
                    }
                    break;
                case 'CC':
                    if (item.EndDate) {
                        this.formGroupFinalidades.get('findCC').setValue(this._globals.getDateFormat(item.EndDate));
                    }
                    break;
                case 'ES':
                    if (item.EndDate) {
                        this.formGroupFinalidades.get('findES').setValue(this._globals.getDateFormat(item.EndDate));
                    }
                    break;
                case 'OT':
                    if (item.EndDate) {
                        this.formGroupFinalidades.get('findOT').setValue(this._globals.getDateFormat(item.EndDate));
                    }
                    break;
                case 'PE':
                    if (item.EndDate) {
                        this.formGroupFinalidades.get('findPE').setValue(this._globals.getDateFormat(item.EndDate));
                    }
                    break;
            }
        });
    }

    onChangeDateSigConsent(event) {
        const nuevaFecha = this._globals.mas12conFecha(event);
        this.formGroupFinalidades.get('findCA').setValue(nuevaFecha);
        this.formGroupFinalidades.get('findCC').setValue(nuevaFecha);
        this.formGroupFinalidades.get('findES').setValue(nuevaFecha);
        this.formGroupFinalidades.get('findPE').setValue(nuevaFecha);
        this.formGroupFinalidades.get('findOT').setValue(nuevaFecha);
        this.formGroupFinalidades.updateValueAndValidity({emitEvent: false});
        this.showModalOnSingDate = true;
    }

    clickCheckBox(name) {
        const value = this._gestionTercerosService.customerForm.controls.contactInformation.get(name).value;
        this._gestionTercerosService.customerForm.controls.contactInformation.get(name).setValue(!value);
    }

    selectAutoriza(checkAllAutoriza) {
        //este boton solo debe desactivar todos los checks
        const autoriza = checkAllAutoriza.currentTarget.checked;
        const incluirEspeciales = false;
        this.marcarSiNo(autoriza, incluirEspeciales);
    }

    selectBox(box) {
        const currentTarget = box.currentTarget as HTMLInputElement;
        this.checkBoxComunVal = {currentTarget};
        const autoriza = box.currentTarget.checked;
        if(autoriza === false && this.canShowModalCA && !this.clienteNuevo){
            this.showModalComunicationAlert = true;
        }else{
            this.selectBoxChangeCheck(box);
        }
    }

    selectBoxChangeCheck(box, modalCandel: boolean = false){
        const auxbox = box.currentTarget.id;
        const autoriza = box.currentTarget.checked;
        switch (auxbox) {
            case 'telefono':
                if(modalCandel){
                    box.currentTarget.checked = true;
                }
                this.telefono.IsActivated = box.currentTarget.checked;
                break;
            case 'mailing':
                if(modalCandel){
                    box.currentTarget.checked = true;
                }
                this.mailing.IsActivated = box.currentTarget.checked;
                break;
            case 'sms':
                if(modalCandel){
                    box.currentTarget.checked = true;
                }
                this.sms.IsActivated = box.currentTarget.checked;
                break;
            case 'whatsApp':
                if(modalCandel){
                    box.currentTarget.checked = true;
                }
                this.whatsApp.IsActivated = box.currentTarget.checked;
                break;
            case 'redesSociales':
                if(modalCandel){
                    box.currentTarget.checked = true;
                }
                this.redesSociales.IsActivated = box.currentTarget.checked;
                break;
            case 'correoPostal':
                if(modalCandel){
                    box.currentTarget.checked = true;
                }
                this.correoPostal.IsActivated = box.currentTarget.checked;
                break;
            case 'fax':
                if(modalCandel){
                    box.currentTarget.checked = true;
                }
                this.fax.IsActivated = box.currentTarget.checked;
                break;
        }
        if(modalCandel){

        }else if (!autoriza) {
            this.autorizaAll -= 1;
        } else {
            this.autorizaAll += 1;
        }
        this.comprobarChanels();
    }

    comprobarChanels() {
        this.customerContactChannelTypeList.forEach((key: any, val: any) => {
            switch (key.ChannelTypeCode) {
                case 'TE':
                    key.IsActivated = this.telefono.IsActivated;
                    break;
                case 'MA':
                    key.IsActivated = this.mailing.IsActivated;
                    break;
                case 'SS':
                    key.IsActivated = this.sms.IsActivated;
                    break;
                case 'WA':
                    key.IsActivated = this.whatsApp.IsActivated;
                    break;
                case 'RS':
                    key.IsActivated = this.redesSociales.IsActivated;
                    break;
                case 'CP':
                    key.IsActivated = this.correoPostal.IsActivated;
                    break;
                case 'FX':
                    key.IsActivated = this.fax.IsActivated;
                    break;
            }
        });
        this._gestionTercerosService.customerForm.controls.contactInformation.get('customerContactChannelTypeList').setValue(this.customerContactChannelTypeList);
    }

    marcarSiNo(autoriza, incluirEspeciales) {
        if(this.customerContactChannelTypeList){
            this.customerContactChannelTypeList.forEach(item => {
                item.IsActivated = autoriza;
            });
            this.autorizaAll = autoriza ? 7 : 0;
            if(incluirEspeciales === true){
                this._gestionTercerosService.customerForm.controls.contactInformation.get('allowContactBrand').setValue(autoriza);
                this._gestionTercerosService.customerForm.controls.contactInformation.get('allowProfilingBrand').setValue(autoriza);
                this._gestionTercerosService.customerForm.controls.contactInformation.get('thirdAssignment').setValue(autoriza);
            }
            this._gestionTercerosService.customerForm.controls.contactInformation.get('customerContactChannelTypeList').setValue(this.customerContactChannelTypeList);
        }
    }

    hasError(name) {
        return this._gestionTercerosService.customerForm.controls.contactInformation.get(name).hasError('required') && this._gestionTercerosService.customerForm.controls.datosPrincipales.get(name).touched;
    }

    hasErrorInvalid(name) {
        return this._gestionTercerosService.customerForm.controls.contactInformation.get(name).errors && this._gestionTercerosService.customerForm.controls.contactInformation.get(name).touched;
    }

    validarEmail(valor) {
        const emailRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~\-ñÑ]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~\-ñÑ]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

        if (valor) {
            this.mailMal = !emailRegex.test(valor);
        } else {
            this.mailMal = false;
        }
        return this.mailMal;
    }

    abrirExcel() {
        this.excel.emit(this.dataCustomer.CustomerId);
    }

    impConsentimientos() {
        const customerCode = this._gestionTercerosService.actualCustomerCode.value;
        const filial = this._authService.getFilialComplete();
        const printParams: IParamsImprimir = {
            type: ImpresosEnum.printConsentimientos,
            number: customerCode,
            filial: filial.filial,
        };
        this._imprimirService.descargarImpreso(printParams, null);
    }

}

